import { Input } from "@/components/ui/input"
import type { CampaignEntry } from "../state/formReducer"

/**
 * One landing-URL row per campaign chip. Parity: `campaigns.js:52-73`.
 * Row state lives in the reducer so we stay single-source-of-truth.
 */

interface Props {
  campaigns: CampaignEntry[]
  onUrlChange: (id: string, url: string) => void
}

export function LandingUrlRows({ campaigns, onUrlChange }: Props) {
  if (campaigns.length === 0) {
    return (
      <p className="text-xs text-white">
        Add a campaign above to configure its landing URL.
      </p>
    )
  }
  return (
    <div className="mt-2 space-y-3">
      {campaigns.map((c) => (
        <div key={c.id} className="flex flex-col gap-1.5">
          <span className="inline-flex w-fit items-center rounded-full border border-[#8fa0ef]/55 bg-[#4a5380] px-2.5 py-0.5 text-xs font-medium text-white">
            {c.name}
          </span>
          <Input
            type="url"
            required
            placeholder="https://your-website.com"
            value={c.url}
            onChange={(e) => onUrlChange(c.id, e.target.value.trim())}
          />
        </div>
      ))}
    </div>
  )
}
